<template>
  <el-popconfirm
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot /><slot
      slot="reference"
      name="reference"
    />
  </el-popconfirm>
</template>

<script>
export default {
  name: 'RtPopconfirm'
}
</script>



// WEBPACK FOOTER //
// rtPopconfirm.vue?2c27572a